import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { Fmsagency } from './fms-agency.model';

@Injectable({
  providedIn: 'root'
})
export class FmsAgencyService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }

  SaveOrUpdateFms(saveList: Fmsagency): Observable<any> {
    let url = "api/FMSAgency/SaveFMSAgency";
    return this.http.post(url, saveList, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }



  DeleteFms(Id: any): Observable<any> {
    let url = "api/FMSAgency/DeleteFMSAgency?";
    return this.http.delete(url+Id, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getFmslist(): Observable<any> {
    var url = "api/FMSAgency/getFMSAgencyDropDownList?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(map(data => data.body),
        catchError(this.errorService.handleError));
}
  
}
